module.exports = __webpack_public_path__ + "img/Intel.c6258c28.svg";